import Loadable, { LoadingSpinner } from '@comeon/loadable';

export const IconLoadingAnimation = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "loading-animation" */
			'./loading-animation/icon-loading-animation.js'
		),
	loading: LoadingSpinner,
	delay: 300
});

const LoadingAnimation = () => (
	<div className="spinner animated-loading">
		<IconLoadingAnimation />
	</div>
);

export default LoadingAnimation;
